import React from 'react';
import './HomePage.css';
import homePic from '../../assets/images/home_pic.jpg'; // Using the same pic, or you can add a new one

function HomePage() {
  return (
    <div className="home-page-container">
      {/* The main text content now comes first in the code */}
      <div className="home-content">
        <span className="eyebrow">Auckland's Premier Saxophonist</span>
        <h2>Meet Evan</h2>
        <div className="home-rule"></div>
        <p>
          Evan performs at music festivals, weddings, birthdays, garden parties and cocktail parties and appreciates how much work goes into organising each event.
        </p>
        {/* The blockquote is no longer here */}
        <p>
          Evan’s favourite type of music is jazz but he enjoys performing a variety of genres so if you have a preference please let him know as Evan is very accommodating. Evan is able to add a sparkle to any event. With his tenor or alto/soprano saxophones, smooth vocals and high quality backing tracks he can create exactly the ambience you want. With many hours of music to play from, including classic Jazz and Latin standards, he will tailor a repertoire of music to suit your event.
        </p>
        <p>
          Jazz musicians have described Evan’s saxophone sounds as “big, round and full-bodied” and his style as “fluid, smooth and varied”.
        </p>
        <p>
          Evan can perform open air or indoors. He plays with quality pro-audio backing tracks through a small portable PA system which allows total mobility without the need for mains electricity. A standard performance consists of 3 x 45 minute sets with a nominal break in between.
        </p>
      </div>

      {/* The image and quote are now grouped together here */}
      <div className="home-image-container">
        <img src={homePic} alt="Evan Reid playing the saxophone" className="home-pic" />
        <blockquote className="home-quote">
          “I take great pride in bringing a professional approach to every one of my engagements and helping you make your event unforgettable.”
        </blockquote>
      </div>
    </div>
  );
}

export default HomePage;